module.exports = __webpack_public_path__ + "static/img/bg.aaf02f90.png";